/**
 * API service for Conditions.
 * Endpoint: /api/conditions/{loanId}
 */
import axios from "axios";

const API_DOMAIN = process.env.REACT_APP_TPOC_API_DOMAIN;

/**
 * Fetch conditions list for a loan.
 * GET /api/conditions/{loanId}
 * @param {string} loanId - loan identifier (route param)
 * @param {string} token - access token for authorization
 * @returns {Promise<Array>} array of condition objects
 */
export const fetchConditions = async (loanId, token) => {
  const response = await axios.get(`${API_DOMAIN}/api/conditions/${loanId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data || [];
};

/**
 * Delete an attachment from a loan.
 * DELETE /api/broker/documents/{loanId}/attachments/{attachmentId}?userId={userId}
 * @param {string} loanId - loan identifier
 * @param {string} attachmentId - attachment identifier
 * @param {string} token - access token for authorization
 * @param {string} userId - user identifier (query param)
 * @returns {Promise<object>} response data with message
 */
export const deleteAttachment = async (loanId, attachmentId, token, userId) => {
  const response = await axios.delete(
    `${API_DOMAIN}/api/broker/documents/${loanId}/attachments/${attachmentId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { userId },
    }
  );
  return response.data;
};
